/* Publish by EComposer at 2024-07-16 08:20:27*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xf9rdvr989j"]=  window.__ectimmers["ecom-xf9rdvr989j"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-xf9rdvr989j"]["yrv4b5kv9"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click(),Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId}),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xf9rdvr989j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xf9rdvr989j', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ny10aiydf6m"]=  window.__ectimmers["ecom-ny10aiydf6m"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ny10aiydf6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ny10aiydf6m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4p8zpf7pfwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4p8zpf7pfwc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6frxxur5jjm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6frxxur5jjm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ujirwlksez').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ujirwlksez', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txj1c8iaj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txj1c8iaj5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9srurby1ilq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9srurby1ilq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-c70o1v486yp"]=  window.__ectimmers["ecom-c70o1v486yp"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-c70o1v486yp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c70o1v486yp', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}